<div class="container">
  <div
    class="line-container"
    *ngFor="let line of lines; let index = index"
  >
    <div class="line-number" (click)="changeLine(index)">{{ index + 1 }}</div>

    <div class="output-box-spacer"></div>

    <input
      #outputBox
      class="output-box"
      readonly
      spellcheck="false"
      [value]="getLine(index)"
      [class.active-line]="index === activeIndex"
      (click)="changeLine(index)"
    />

    <div class="flex-spacer"></div>

    <!-- SVG is based on the one below -->
    <svg
      class="minus-button clickable"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      enable-background="new 0 0 48 48"
      (click)="deleteLine(index)"
    >
      <circle cx="24" cy="24" r="21" />
      <rect fill="#36393f" x="14" y="21" width="20" height="6" />
    </svg>

    <div class="flex-spacer"></div>

    <!-- SVG from Free Preloaders on freeicons.io (modified) -->
    <svg
      class="plus-button clickable"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      enable-background="new 0 0 48 48"
      (click)="addLine(index)"
    >
      <circle cx="24" cy="24" r="21" />
      <g fill="#36393f">
        <rect x="21" y="14" width="6" height="20" />
        <rect x="14" y="21" width="20" height="6" />
      </g>
    </svg>
  </div>
</div>
